/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ChartTypes {
    Unknown = 0,
    User = 1,
    DefaultUI = 2,
    Release = 3,
    Top = 10,
    Hot = 11,
    Newest = 12,
    Recommended = 13,
    Artist = 14,
}
